export default "__VITE_ASSET__89ac62b9__"